// src/components/blog/BlogPostCta.tsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import StoreBadgeLink from '../StoreBadgeLink';
import { SecondaryButton } from '../../styles/layout';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../../constants/storeLinks';
import { BlogProduct } from '../../types/blogTypes';

const Box = styled.aside`
  margin-top: 56px;
  padding: 36px 32px;
  text-align: center;
  border-radius: 18px;
  background: linear-gradient(145deg, #1c3650 0%, #0f1c2d 100%);
  box-shadow: 0 20px 40px rgba(15, 28, 45, 0.25);
  display: grid;
  gap: 12px;
  justify-items: center;

  h2,
  p {
    color: #f7fbff;
    margin: 0;
  }

  h2 {
    font-size: clamp(24px, 3vw, 32px);
  }

  p {
    max-width: 520px;
    line-height: 1.6;
    color: rgba(247, 251, 255, 0.85);
  }
`;

const Badges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  margin-top: 8px;
`;

interface BlogPostCtaProps {
  product: BlogProduct;
  buddy?: string;
}

const BuddiesCta: React.FC<{ buddy?: string }> = ({ buddy }) => (
  <Box>
    <h2>{buddy ? `Say hi to ${buddy}` : 'Meet your Chot Buddies'}</h2>
    <p>Free to start on Android and iOS. Pick a buddy, talk or type, and start your first conversation.</p>
    <Badges>
      <StoreBadgeLink store="google-play" href={GOOGLE_PLAY_URL} label="Get Chot Buddies on Google Play" />
      <StoreBadgeLink store="apple" href={APP_STORE_URL} label="Download Chot Buddies on the App Store" />
    </Badges>
  </Box>
);

const StudyCta: React.FC = () => (
  <Box>
    <h2>Chot Study is coming soon</h2>
    <p>Turn your own notes and documents into questions, summaries and study games.</p>
    <SecondaryButton as={Link} to="/products/chot-study/">
      See what Chot Study will do
    </SecondaryButton>
  </Box>
);

const BlogPostCta: React.FC<BlogPostCtaProps> = ({ product, buddy }) =>
  product === 'chot-study' ? <StudyCta /> : <BuddiesCta buddy={buddy} />;

export default BlogPostCta;
